/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * The type of external registry that is being configured.
 */
export enum ExternalRegistryKind {
	ECR = "ECR",
	DOCKER_HUB = "DockerHub",
}
